import common from "../common";
import BaseStage from "./BaseStage";
import TutorialFinger from "../reusableModules/TutorialFinger";
import Gesture from "../reusableModules/Gesture";
import Oven from "./Stage_Oven_Objects/Oven";
import Timer from "./Stage_Oven_Objects/Timer";
import ParticleEmitter from "../reusableModules/ParticleEmitter";

/**
 * Baking
 */
export default class Stage_Oven extends BaseStage {
    constructor() {
        super("oven_1");
        this._text = null;
        this._bindings = {};

        this._ovenGlove = null;
        this._oven = null;
        this._ovenCookies = null;
        this._continueActive = false;
        this._clickingTutorialFinger = null;
        this._steamParticleEmitter = null;
        this._trayOpenEmitter = null;

        this._gesturesArray = [];
    }

    init() {
        super.init(P3.audio.playMusic("music_ambient_music_loop_00"));

        let bk = new PIXI.Sprite(P3.assets.texture('bg_oven'));
        bk.anchor.set(0.5);
        bk.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        bk.width = 1900;
        this.addChild(bk);

        this.createOven();
        this.createParticleEmitter();
        this.createGestures();
        this._ovenGlove = new PIXI.Sprite(P3.assets.texture('oven_glove'));
        this._ovenGlove.anchor.set(0.5);
        this._ovenGlove.scale.set(0.8);
        this._ovenGlove.position.set(common.STAGE_WIDTH * 0.5 - 200, common.STAGE_HEIGHT * 0.5 + 300);
        this.addChild(this._ovenGlove);
        if(PIXI.utils.isMobile.any)
            this._ovenGlove.visible = false;
        this.activateGesture();
        this.createUI();
    }

    destroy() {
        for (const i in this._bindings) {
            if (this._bindings.hasOwnProperty(i)) {
                const binding = this._bindings[i];
                binding.detach();
            }
        }
        this._bindings = {};

        super.destroy();
    }

    resize() {
        super.resize();
    }

    animateIn() {
        super.animateIn();
    }

    update() {
        super.update();

        this._oven.update(P3.Ticker.dt);
        this._timer.update(P3.Ticker.dt);

        if(this._clickingTutorialFinger !== null)
            this._clickingTutorialFinger.update();

        if(this._steamParticleEmitter)
            this._steamParticleEmitter.update();

        if(this._trayOpenEmitter)
            this._trayOpenEmitter.update();
    }

    pauseGame() {
        super.pauseGame();
    }

    resumeGame() {
        super.resumeGame();
    }

    createOven(){
        this._oven = new Oven();
        this._oven.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(this._oven);

        this._timer = new Timer();
        this._timer.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(this._timer);

        this._bindings.ovenOpened = this._oven._ovenOpened.add(()=>{
            new P3.utils.TWEEN.Tween(this._steamParticleEmitter, this.tweens)
                .to({
                    alpha: 1
                }, 2000)
                .onStart(()=>{
                    this.onStageComplete();
                })
                .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
                .onComplete(()=>{
                    //this.signals.next.dispatch();
                })
                .start();

            P3.audio.playSound("sfx_open_oven_00");
        }, this);
        this._bindings.ovenClosed = this._oven._ovenClosed.add(()=>{
            P3.audio.playSound("sfx_close_oven_00");
            this._timer.playTimer();
            new P3.utils.TWEEN.Tween(this._steamParticleEmitter, this.tweens)
                .to({
                    alpha: 0
                }, 1500)
                .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
                .start();
        }, this);
        this._bindings.timerFinished = this._timer._finished.add(()=>{
            new P3.utils.TWEEN.Tween(this._timer, this.tweens)
                .to({
                    y: 1500
                }, 500)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onComplete(() => {
                    new P3.utils.TWEEN.Tween(this._timer, this.tweens)
                        .to({},0)
                        .easing(P3.utils.Easing.Back2.Out)
                        .delay(500)
                        .onComplete(() => {
                            this._oven.playOpenOven();
                        })
                        .start();
                })
                .start();
        }, this);

        this.interactive = true;

        this.on('pointerout', ()=>{
            this._gloveFollow = false;
        });

        this.on('pointerover', ()=>{
            this._gloveFollow = true;
        });

        this.on('pointermove', (event)=>{
            if(this._gloveFollow){
                let position = event.data.getLocalPosition(this);
                this._ovenGlove.position.set(position.x, position.y);
                if(this._clickingTutorialFinger !== null)
                    this._clickingTutorialFinger.turnOff();
            }
        });
    }

    //=========================
    //GESTURES
    //=========================

    createGestures() {
        let allTextures = ["oven_magic"];
        let allPoints = [];

        let points = [
            new PIXI.Point(56, 365.8),
            new PIXI.Point(56, 10),
        ];
        allPoints.push(points);

        for (let i = 0; i < allPoints.length; i++) {
            let gesture = new Gesture(P3.assets.texture(allTextures[i]), allPoints[i], false);
            gesture.visible = false;
            this.addChild(gesture);
            this._gesturesArray.push(gesture);
        }
    }

    activateGesture() {
        let selected = common.randomSelection(this._gesturesArray);
        selected.createPoints();
        selected.sprite.scale.set(0.8);
        selected.x = common.STAGE_WIDTH * 0.5 - selected.width * 0.5;
        selected.y = common.STAGE_HEIGHT * 0.5 - selected.height * 0.5 + 110;
        selected.visible = true;
        this._gesture = selected;

        this._gesture.alpha = 0;
        new P3.utils.TWEEN.Tween(this._gesture, this.tweens)
            .to({
                alpha: 1
            }, 1500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onComplete(()=>{
                this.gestureTutorialAnimation(selected);
            })
            .start();

        this._bindings.help = this.signals.helpTutorial.add(()=>{
            if(this._clickingTutorialFinger){
                this._clickingTutorialFinger.turnOff();
                this._clickingTutorialFinger.play();
            }
        }, this);
    }

    onGestureComplete() {
        this._gestureComplete = true;

        new P3.utils.TWEEN.Tween(this._ovenGlove, this.tweens)
            .to({
                alpha: 0
            }, 500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();

        if(this._clickingTutorialFinger)
            this._clickingTutorialFinger.fade(false, 500, true);

        new P3.utils.TWEEN.Tween(this._gesture, this.tweens)
            .to({
                alpha: 0
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onStart(()=>{
                if (this._gesturesArray[0] && this._gesturesArray[0].pointSprites[0])
                {
                    this._gesturesArray[0].pointSprites[0].visible = false;
                }
                
            })
            .onComplete(()=>{
                for (let i = 0; i < this._gesturesArray.length; i++) {
                    let temp = this._gesturesArray[i];
                    temp.destroy();
                }
                this._gesturesArray = [];
                this._oven.playCloseOven();
                this.removeChild(this._clickingTutorialFinger);
                this._clickingTutorialFinger = null;
            })
            .start();

        P3.audio.playSound("sfx_stage_complete_00");
        this._bindings.help.detach();
    }

    gestureTutorialAnimation(gesture){
        if(this._clickingTutorialFinger !== null) return;

        this._bindings.gestureComplete = gesture.signals.complete.add(this.onGestureComplete, this);
        this._bindings.gestureStarted = gesture.signals.firstTouch.add(function () {
            this._clickingTutorialFinger.turnOff();
        }, this);

        this._clickingTutorialFinger = new TutorialFinger({
            x: gesture.pointSprites[0].x + gesture.x + 75,
            y: gesture.pointSprites[0].y + gesture.y
        }, 10, -1, "oven_glove");
        this.addChild(this._clickingTutorialFinger);

        this._clickingTutorialFinger.fade(true, 500, false);
        this._clickingTutorialFinger.clickDown();


        const selectedElement = gesture.pointSprites[1];
        //console.log(selectedElement);
        let tween = new P3.utils.TWEEN.Tween(this._clickingTutorialFinger._view, this.tweens)
            .to({
                x: selectedElement.x + gesture.x + 75,
                y: selectedElement.y + gesture.y
            }, 1500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);
        this._clickingTutorialFinger.addStep(tween);

        this._clickingTutorialFinger.clickUp();
        this._clickingTutorialFinger.fade(false, 500, false);
        this._clickingTutorialFinger.addDelay(500);
        this._clickingTutorialFinger.play();
    }

    createParticleEmitter(){
        let emitter = (particleData, particleTextures, position)=>{
            let emitter = new ParticleEmitter(particleData, particleTextures);
            emitter.position.set(position.x, position.y);
            this.addChildAt(emitter, 1);
            return emitter;
        };

        this._steamParticleEmitter = emitter(ParticleEmitter.OVER_STEAM_LOOP_00, ParticleEmitter.STEAM_CLOUD,
            {x: common.STAGE_WIDTH * 0.5 - 5, y: common.STAGE_HEIGHT * 0.5 - 60});
        this._steamParticleEmitter.play();
        this._steamParticleEmitter.alpha = 0;
        new P3.utils.TWEEN.Tween(this._steamParticleEmitter, this.tweens)
            .to({
                alpha: 1
            }, 3000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .start();


        this._trayOpenEmitter = emitter(ParticleEmitter.OVEN_TRAY_COMPLETE, ParticleEmitter.STEAM_CLOUD,
            {x: common.STAGE_WIDTH * 0.5 - 5, y: common.STAGE_HEIGHT * 0.5 - 60});
    }
}